import ReactMarkdown from 'react-markdown'

import remarkHeadingId from 'remark-custom-heading-id'
import remarkGfm from 'remark-gfm'

import { useLocalFile } from '../../data/tenantFiles/hooks'

type LocalMarkdownProps = {
  filename: string
}

export const LocalMarkdown: React.FC<LocalMarkdownProps> = ({ filename }) => {
  const { data } = useLocalFile(filename)

  if (!data) return null

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm, remarkHeadingId]}
      children={data}
    />
  )
}
